import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m30.702 28.696.549 1.147 1.24-.286-.556 1.144.997.79-1.241.28.003 1.273-.992-.796-.993.796.004-1.273-1.24-.28.996-.79-.555-1.144 1.239.286.549-1.147Zm-5.106-12.174.55 1.147 1.238-.286-.555 1.145.997.79-1.24.28.003 1.271-.993-.795-.992.795.003-1.271-1.24-.28.996-.79-.555-1.145 1.24.286.548-1.147Zm5.106-6.957.549 1.148 1.24-.287-.556 1.145.997.79-1.241.28.003 1.272-.992-.796-.993.796.004-1.272-1.24-.28.996-.79-.555-1.145 1.239.287.549-1.148Zm4.459 5.218.55 1.147 1.239-.286-.555 1.144.996.79-1.24.28.003 1.273-.993-.796-.992.796.004-1.273-1.241-.28.996-.79-.555-1.144 1.24.286.548-1.147Zm-3.188 6.087.431 1.328h1.397l-1.13.821.432 1.329-1.13-.821-1.13.82.431-1.328-1.13-.82h1.397l.432-1.33Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M22.174 25.652a5.652 5.652 0 1 1 2.689-10.625 6.957 6.957 0 1 0 0 9.945c-.8.434-1.716.68-2.69.68ZM12.577 7.826a3.476 3.476 0 0 0-6.024 0h6.024Zm.012.02L9.565 10.87 6.542 7.846a3.478 3.478 0 1 0 6.047 0Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#A2001D",
  d: "M8.696 10v2.934a3.487 3.487 0 0 0 1.739 0V10h-1.74Z"
}, null, -1), d = [
  n,
  s,
  c,
  h
];
function i(a, _) {
  return e(), l("svg", o, [...d]);
}
const m = { render: i };
export {
  m as default,
  i as render
};
